import program from "./program";

export default {
	program
};
